import {AdviceComponent} from "./advice.component";

export const Advice = AdviceComponent;
